/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'organization-data-tree-view-alt': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M14.375 5.628h3.75c.69 0 1.25-.56 1.25-1.25v-2.5c0-.69-.56-1.25-1.25-1.25h-3.75c-.69 0-1.25.56-1.25 1.25v.625h-6.25v-.625c0-.69-.56-1.25-1.25-1.25h-3.75c-.69 0-1.25.56-1.25 1.25v2.5c0 .69.56 1.25 1.25 1.25h3.75c.69 0 1.25-.56 1.25-1.25v-.625h2.5v12.5c0 .69.56 1.25 1.25 1.25h2.5v.625c0 .69.56 1.25 1.25 1.25h3.75c.69 0 1.25-.56 1.25-1.25v-2.5c0-.69-.56-1.25-1.25-1.25h-3.75c-.69 0-1.25.56-1.25 1.25v.625h-2.5v-5.625h2.5v.625c0 .69.56 1.25 1.25 1.25h3.75c.69 0 1.25-.56 1.25-1.25v-2.5c0-.69-.56-1.25-1.25-1.25h-3.75c-.69 0-1.25.56-1.25 1.25v.625h-2.5V3.753h2.5v.625c0 .69.56 1.25 1.25 1.25zm0-3.75h3.75v2.5h-3.75v-2.5zm-8.75 2.5h-3.75v-2.5h3.75v2.5zm8.75 11.25h3.75v2.5h-3.75v-2.5zm0-6.875h3.75v2.5h-3.75v-2.5z"/>'
  }
})
